export const IMAGE_TYPES = {
  COMPANY_LOGO: 'company_logo',
  FAVICON: 'favicon',
  WALKTHROUGH_THUMBNAIL: 'walkthrough_thumbnail',
  WALKTHROUGH_LOGO: 'walkthrough_logo'
};
